import { rem } from 'polished';
import styled from 'styled-components';
import { DESKTOP_HEADER_HEIGHT, MOBILE_HEADER_HEIGHT } from '../../constants';
import { breakpoints } from '../../styles/theme';

export const Wrapper = styled.div`
    margin-top: ${rem(MOBILE_HEADER_HEIGHT)};
    padding: 0 ${rem(20)};

    @media (min-width: ${breakpoints.sm}px) {
        margin-top: ${rem(DESKTOP_HEADER_HEIGHT)};
    }

    .title {
        font-size: ${rem(30)};
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
        color: ${({ theme }) => theme.colors.primary};
        display: block;
        text-align: center;
        padding-bottom: ${rem(25)};
        margin-top: ${rem(65)};
    }

    .subTitle {
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
        display: block;
        text-align: center;
        padding-bottom: ${rem(25)};
    }


    h1.sectionTitle {
        font-size: ${rem(18)};
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
        display: block;
        padding: ${rem(20)} 0;
    }

    h2.sectionTitle {
        font-size: ${rem(16)};
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
        display: block;
        padding: ${rem(20)} 0;
    }

    .underline {
        text-decoration: underline;
    }

    .marginLeft {
        margin-left: ${rem(20)};
    }

    .section {
        a {
            color: ${({ theme }) => theme.colors.primary};
            padding-right: ${rem(4)};
            display: inline-flex;
        }
    }
`;
